import React, { useState, useEffect, useRef, useMemo } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './TauriSectionModalVisual.css';
import setting from '../../../config.json';
import { useFilterContext } from '../../TauriGlobalContext/TauriGlobalContext';
import TauriSectionBaseVisual from '../TauriSectionBaseVisual';
import TauriHostContainer from '../../TauriHostContainer/TauriHostContainer';

const TauriSectionModalVisual = ({ show, onHide, selectedData, visual, columnSize, rowSize, style, palettes, themes }) => {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const [selectedOption, setSelectedOption] = useState(0); // Set initial state to index of first option
    const [isOpen, setIsOpen] = useState(false);
    const [isMaximized, setIsMaximized] = useState(false);
    const [updatedVisual, setUpdatedVisual] = useState(null);
    const { filterValue } = useFilterContext();

    const handleMaximizeClick = () => {
        setIsMaximized(true);
    };

    const handleRestoreClick = () => {
        setIsMaximized(false);
    };

    const dropdownRef = useRef(null);

    useEffect(() => {
        setSelectedOption(0); // select first item in dropdown by default

        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    const handleOutsideClick = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false); // Close the dropdown menu if clicked outside
        }
    };

    const updateParameters = (visualConfig, selectedData) => {
        // Deep clone the visualConfig object to avoid mutating the original object
        const updatedConfig = JSON.parse(JSON.stringify(visualConfig));
    
        const updateVisualParameters = (visual) => {
            if (visual.binding && visual.binding.data && visual.binding.data.parameters) {
                visual.binding.data.parameters.forEach((param) => {
                    if (param.key === selectedData.title) {
                        // Update the parameter value
                        param.value = selectedData.selectedVal;
                    }
                });
            }
        };
    
        // Iterate over each visual in the array and update its parameters
        updatedConfig.forEach((item) => {
            updateVisualParameters(item.visual);
        });
    
        return updatedConfig;
    };
    
    const itemSection = useMemo(() => {
        return updateParameters(visual, selectedData);
    }, [visual, selectedData]);

    return (
        <Modal
            show={show}
            onHide={onHide}
            className={`section-modal-visual ${isMaximized ? 'maximized' : ''} resizable`}
            centered>
            <Modal.Header className="section-modal-header">
                <div className="d-flex flex-column w-100">
                    <div className="d-flex">
                        <div className="chart-title">
                            {selectedData.selectedTitle?.toUpperCase()}
                            {selectedData.modalTitle && ` by ${selectedData.modalTitle?.toUpperCase()}`}
                            {' ('} 
                            {monthNames[filterValue.FromMonth - 1]}
                            {'-'}
                            {filterValue.FromYear}
                            {' to '}
                            {monthNames[filterValue.ToMonth - 1]}
                            {'-'}
                            {filterValue.ToYear}
                            {')'}
                        </div>
                        <div className="ms-auto d-flex">
                            {isMaximized ? (
                                <Button className='button-minimize align-items-center d-none d-xl-flex' variant='light' onClick={handleRestoreClick}>
                                    <img src={process.env.PUBLIC_URL + "/Images/arrow-minimize.svg"} alt="Icon"/>
                                </Button>
                            ) : (
                                <Button className='button-maximize align-items-center d-none d-xl-flex' variant='light' onClick={handleMaximizeClick}>
                                    <img src={process.env.PUBLIC_URL + "/Images/arrow-maximize.svg"} alt="Icon"/>
                                </Button>
                            )}
                            <Button className='button-close' variant='light' onClick={onHide}>
                                <img src={process.env.PUBLIC_URL + "/Images/material-symbols--close.svg"} alt="Icon"/>
                            </Button>
                        </div>
                    </div>
                    <div className='selected-desc'>{selectedData.selectedDesc}</div>
                </div>
            </Modal.Header>
            <Modal.Body className="section-modal-body"
                style={{
                    height: `${setting.hostSectionHeight * rowSize}rem`,
                }}>
                <TauriHostContainer itemSection={itemSection} chartPalette={palettes} chartTheme={themes}/>
            </Modal.Body>
            <Modal.Footer className='section-modal-footer'>

            </Modal.Footer>
        </Modal>
    );
};

export default TauriSectionModalVisual;